import { Box, themedColor } from '@lemonade-hq/cdk';
import { rgba } from 'polished';
import type React from 'react';
import styled, { type DefaultTheme } from 'styled-components';
import { SectionParagraph } from '../shared/Content';

const FooterContainer = styled(Box)`
  background: ${themedColor('darkestNight')};
  color: ${({ theme }: { theme: DefaultTheme }) => rgba(theme.colors.metal, 0.5)};
`;

const FooterContent = styled(SectionParagraph)`
  margin: auto;
  max-width: 1246px;
  font-size: 1.4rem;
  line-height: 2.1rem;
  text-align: left;
`;

export const Disclaimer: React.FC = () => (
  <FooterContainer px={[20, 20, 60]} pb={[40, 40, 60]} mt={[-1]}>
    <FooterContent>
      Lemonade Life Insurance Agency, LLC (LLIA) is acting as the agent of Banner Life, whose life insurance products
      are underwritten and issued by Banner Life Insurance Company Urbana, MD. Banner Life products are distributed in
      49 states and in DC. Banner Life is not authorized as an insurer and does not do business in New York. OPTerm
      policy form # ICC21-DTCV and state variations. RiseTerm Form #ICC24-DTCV3 & ICC23-DT1-SCH and state variations.
      Premiums based on preferred plus non-tobacco, preferred non-tobacco, standard plus non-tobacco, standard
      non-tobacco, preferred tobacco and standard tobacco underwriting classes. Policy descriptions provided here are
      not a statement of contract. Please refer to the policy forms for full disclosure of all benefits and limitations.
      LLIA receives compensation for the insurance policies it sells. Products or issue ages may not be available in all
      jurisdictions. Limitations or restrictions may apply. Our application asks about your lifestyle and health.
    </FooterContent>
  </FooterContainer>
);
